// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layout--with-title[data-v-febc4f54]{display:flex;flex-direction:column;justify-content:center;row-gap:4px;text-align:center}.layout--with-title .title b[data-v-febc4f54]{font-size:14px;font-weight:700;line-height:21px}.layout--with-title .body[data-v-febc4f54]{color:#000;font-size:13px}.level--alert .title b[data-v-febc4f54]{color:#db4c55}.level--caution .title b[data-v-febc4f54]{color:#7fc648}", ""]);
// Exports
module.exports = exports;
